export enum DataLayerPageType {
  Aztec = 'Aztec',
  AztecLive = 'AztecLive',
  Calculator = 'Kalkulator',
  Checkout = 'Checkout',
  ConvertedToApplication = 'Konwersja kwotacji',
  DocumentsUpload = 'Upload dokumentów',
  EmailVerified = 'Email zweryfikowany',
  FailHiProPayment = 'Błąd płatności HiPro',
  FailPayment = 'Błąd płatności',
  NotificationsDisabling = 'Wyłączanie powiadomień',
  OfferList = 'Lista ofert',
  Payment = 'Płatność',
  SimpleDocumentsUpload = 'Uproszczony upload dokumentów',
  SuccessPayment = 'Pomyślna płatność',
  TerminationGenerator = 'Generator wypowiedzenia OC',
  UserProfile = 'Profil użytkownika',
  WaitingPayment = 'Oczekiwanie na potwierdzenie płatności',
  WrongEmailVerification = 'Błąd weryfikacji maila',
}
